module.exports = __webpack_public_path__ + "static/img/008.2bb7797c.png";